module.exports = __webpack_public_path__ + "static/media/tutorial-follower.0569ee84.png";